import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Flag, Plus, Trash2 } from 'lucide-react';
import { useToast } from '@/components/ui/use-toast';

const FlagManager = ({ flags, onAddFlag, onRemoveFlag }) => {
  const { toast } = useToast();
  const [isOpen, setIsOpen] = useState(false);
  const [flagName, setFlagName] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!flagName.trim()) {
      toast({ title: "Erro", description: "Por favor, digite o nome da bandeira.", variant: "destructive" });
      return;
    }

    if (flags.some(flag => flag.name.toLowerCase() === flagName.toLowerCase())) {
      toast({ title: "Erro", description: "Esta bandeira já está cadastrada.", variant: "destructive" });
      return;
    }

    onAddFlag({
      id: Date.now(),
      name: flagName.trim()
    });

    toast({ title: "Sucesso!", description: "Bandeira cadastrada com sucesso!" });
    setFlagName('');
    setIsOpen(false);
  };

  const handleRemove = (flagId) => {
    onRemoveFlag(flagId);
    toast({ title: "Bandeira removida", description: "A bandeira foi removida com sucesso." });
  };

  return (
    <Card className="glass-effect border-white/20">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-white">
          <Flag className="w-5 h-5" />
          Gerenciar Bandeiras
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
          <DialogTrigger asChild>
            <Button className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white">
              <Plus className="w-4 h-4 mr-2" />
              Adicionar Bandeira
            </Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2"><Flag className="w-5 h-5" />Nova Bandeira</DialogTitle>
            </DialogHeader>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="flagName">Nome da Bandeira</Label>
                <Input id="flagName" placeholder="Ex: Visa, Mastercard..." value={flagName} onChange={(e) => setFlagName(e.target.value)} required />
              </div>
              <div className="flex justify-end gap-3">
                <Button type="button" variant="outline" onClick={() => setIsOpen(false)}>Cancelar</Button>
                <Button type="submit" className="bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700">Adicionar</Button>
              </div>
            </form>
          </DialogContent>
        </Dialog>

        <div className="space-y-2 max-h-60 overflow-y-auto">
          {flags.length === 0 ? (
            <p className="text-white/70 text-center py-4">Nenhuma bandeira cadastrada.</p>
          ) : (
            flags
              .sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'))
              .map((flag, index) => (
              <div key={flag.id} className="flex items-center justify-between p-3 bg-white/10 rounded-lg backdrop-blur-sm border border-white/20">
                <span className="text-white font-medium">{flag.name}</span>
                <Button size="sm" variant="ghost" onClick={() => handleRemove(flag.id)} className="text-red-400 hover:text-red-300 hover:bg-red-500/20">
                  <Trash2 className="w-4 h-4" />
                </Button>
              </div>
            ))
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default FlagManager;